import { styled, Button } from "@mui/material";

export const IntroductionPage = styled("div")(() => ({
  width: "100vw",
  height: "calc(90vh - 50px)",
  // backgroundColor: "#3957D2",
  maxHeight: "calc(100vh - 50px)",
  maxWidth: "100vw",
  overflow: "hidden",
}));

export const IntroductionScreen = styled("div")(() => ({
  width: "100vw",
  height: "calc(90vh - 50px)",
  backgroundColor: "transparent",
  // position: "absolute",
  // top: "50px",
  display: "flex",
  flexDirection: "row",
  flexWrap:'wrap'
  // justifyContent:'space-between',
}));

export const ProfileImageContainer = styled("div")(({theme}) => ({
  width: "40%",
  height: "100%",
  display: "grid",
  placeItems: "center",
  [theme.breakpoints.down('lg')]:{
    width: "50%",
  },
  [theme.breakpoints.down('md')]:{
    width: "40%",
    height: "100%",
  },
  [theme.breakpoints.down('sm')]:{
    width: "100%",
    height: "50%",
  }
  // backgroundColor:'red'
}));

export const ProfileImage = styled("div")(({ url }) => ({
  width: "300px",
  height: "300px",
  borderRadius: "100%",
  position: "absolute",
  backgroundImage: `url('${url}')`,
  backgroundPosition: "center",
  backgroundSize: "cover",

  border: "1px solid white",
}));

export const IntroData = styled("div")(({theme,dark}) => ({
  width: "60%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  // backgroundColor:'red',
  "& .intro-header": {
    fontSize: "7em",
    color: dark?"#1C2028":"#fff",
    margin: "0",
  },
  "& .subtitle-text": {
    color: dark?"#1C2028":"#fff",
    fontSize: "3em",
  },
  [theme.breakpoints.down('lg')]:{
    width: "50%",
    "& .intro-header": {
      fontSize: "5em",
      margin: "0",
    },
    "& .subtitle-text": {
      color: "#fff",
      fontSize: "4em",
    },
  },
  [theme.breakpoints.down('md')]:{
    width: "60%",
    height: "100%",
    paddingLeft:'100px',

    "& .intro-header": {
      fontSize: "3.5em",
      margin: "0",
    },
    "& .subtitle-text": {
      color: "#fff",
      fontSize: "2.5em",
    },
  },
  [theme.breakpoints.down('sm')]:{
    width: "100%",
    height: "50%",
    padding:'0px 30px',

    "& .intro-header": {
      fontSize: "2.5em",
      margin: "0",
    },
    "& .subtitle-text": {
      color: "#fff",
      fontSize: "1.6em",
    },
  }
}));

export const DownloadBtn = styled("a")(({dark}) => ({
  width: "fit-content",
  height: "fit-content",
  backgroundColor:  dark?"#1C2028":"#fff",
  padding: "10px 20px",
  color: dark?"#FF3B81":"#3957D2",
  fontWeight: 700,
  marginTop:'50px',
  borderRadius:'5px',
  textDecoration:'none',
  display:'flex',
  flexDirection:'row',
  alignItems:'center',
  "&:hover": {
    backgroundColor:  dark?"#1C2028":"#fff",
  },
  '& svg':{
      marginLeft:10
  }
}));
